import { useNavigate } from 'react-router-dom';
import { Button, ButtonGroup } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface Props {
  canContinue: boolean;
  canGoBack?: boolean;
  navigateTo?: string;
  isNavigation: boolean;
  onContinueClicked?: () => void;
}

const CustomBottomButtonGroup = ({
  canContinue,
  canGoBack = true,
  navigateTo,
  isNavigation,
  onContinueClicked
}: Props) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    const isNotNavigationButton = !isNavigation && onContinueClicked;
    return isNotNavigationButton ? onContinueClicked() : navigate(navigateTo ?? '/');
  };

  return (
    <ButtonGroup variant='outlined' aria-label='button group'>
      {canGoBack && (
        <Button color='error' startIcon={<ArrowBackIosIcon />} onClick={() => navigate(-1)}>
          Regresar
        </Button>
      )}
      <Button
        color='primary'
        variant={canContinue ? 'contained' : 'outlined'}
        endIcon={<ArrowForwardIosIcon />}
        disabled={!canContinue}
        onClick={onClickHandler}
      >
        Continuar
      </Button>
    </ButtonGroup>
  );
};

export default CustomBottomButtonGroup;
